export enum ActionEnum {
    QUOTE_SHIPMENT = 'QUOTE_SHIPMENT',
    QUOTE_MULTI_SHIPMENT = 'QUOTE_MULTI_SHIPMENT',
    SHIPMENT_SUBMIT = 'SHIPMENT_SUBMIT',
    SHIPMENT_SUBMIT_MULTI = 'SHIPMENT_SUBMIT_MULTI',
    SHIPMENT_CREATE = 'SHIPMENT_CREATE',
    SHIPMENT_VOID = 'SHIPMENT_VOID',
    SHIPMENT_VOID_MULTI = 'SHIPMENT_VOID_MULTI',
    PICKUP_BOOK = 'PICKUP_BOOK',
    PICKUP_CANCEL = 'PICKUP_CANCEL'
}
